import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { Dialog, DialogContent, DialogActions } from '../../../common/components';

const S = {
  Dialog: styled(Dialog)`
    .paper {
      position: relative;
      width: 480px;
      padding: 32px 40px 24px;
    }
  `,
  DialogContent: styled(DialogContent)`
    margin-bottom: 40px;
  `,
  DialogActions: styled(DialogActions)`
    display: flex;
  `,
  CancelButton: styled(Button)`
    min-width: 80px;
    min-height: 40px;
    border-color: ${({ theme }) => theme.palette.grey[400]};
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
    font-weight: 500;
    line-height: 1.54;
  `,
  DeleteButton: styled(Button)`
    min-width: 80px;
    min-height: 40px;
    color: ${({ theme }) => theme.palette.error.main};
    border-color: ${({ theme }) => theme.palette.error.main};
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
    font-weight: 500;
    line-height: 1.54;
    :focus,
    :hover {
      background-color: ${({ theme }) => theme.palette.hexToRgb(theme.palette.error.main, 0.08)};
    }
  `,
};

const DeleteGroupCheckDialog = ({
  group, open, onClick, onClose,
}) => {
  const handleClick = useCallback(() => {
    onClose();

    onClick();
  }, [onClick, onClose]);

  return (
    <S.Dialog open={open} onClose={onClose}>
      <S.DialogContent>
        {`${group} 그룹을 삭제하시겠습니까?`}
        <br />
        연락처는 삭제되지 않습니다.
      </S.DialogContent>
      <S.DialogActions>
        <S.CancelButton type="button" variant="outlined" onClick={onClose}>
          취소
        </S.CancelButton>
        <S.DeleteButton type="button" variant="outlined" onClick={handleClick}>
          삭제
        </S.DeleteButton>
      </S.DialogActions>
    </S.Dialog>
  );
};

DeleteGroupCheckDialog.propTypes = {
  group: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

DeleteGroupCheckDialog.defaultProps = {
  group: '',
};

export default DeleteGroupCheckDialog;
